import { Btn, Label } from "@/components/site/Ui";
import { useSeo } from "@/lib/seo";

export default function NotFound() {
  useSeo({ title: "Page introuvable", description: "Cette page n'existe pas ou a été déplacée.", noindex: true });
  return (
    <section className="wrap flex min-h-[80vh] flex-col justify-center pt-32 pb-20" data-testid="not-found">
      <Label className="mb-6">Erreur 404</Label>
      <h1 className="display h-xl max-w-3xl">Cette page n'existe pas.</h1>
      <div className="mt-10"><Btn to="/" testid="not-found-home">Retour à l'accueil</Btn></div>
    </section>
  );
}
